var React = require('react');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');
var CreateProfile = require('./ReactDependencies/CreateProfile.jsx');
var Credentials = require('./ReactDependencies/Credentials.jsx');
var EmailAndPassword = require('./ReactDependencies/EmailAndPassword.jsx');
var labels = require('MemberJoinLabels');
var accountDataService = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx');
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');
var emitter = require('../../../../Scripts/React/EventEmitter.js');
var configVariables = require('ConfigVariables');
const _recaptchaRef = React.createRef();
const ReCAPTCHA = React.lazy(() => import(/* webpackChunkName: "recaptcha" */ 'react-google-recaptcha'));

class Step2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emailAccountExists: false,
            emailAddress: props.stepState.emailAddress,
            userAccountExists: false,
            customersMaskInfo: [],
            dismissMaskedUsers: false,
            isCreatingAccount: false,
            recaptchaToken: null 
        }

        this.bindFunctions();
    }

    componentDidMount() {
        this.props.loadApiData('prefix');
        this.props.loadApiData('suffix');

        if (!this.props.appState.isMilitary) {
            this.props.loadApiData('militaryPrefix');
        }

        if (!this.props.appState.isInternational) {
            var stateFetchOptions = {
                queryString: () => '?countryCode=' + 'USA'
            }
            this.props.loadApiData('statesByCountry', stateFetchOptions);
        }

        this.props.loadApiData('districts');
    }

    bindFunctions() {
        this.checkIfEmailExists = this.checkIfEmailExists.bind(this);
        this.checkIfUserExists = this.checkIfUserExists.bind(this);
        this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);

        this.createNewAccount = this.createNewAccount.bind(this);
        this.goNextStep = this.goNextStep.bind(this);
        this.checkUserExistingModal = this.checkUserExistingModal.bind(this);
        this.dismissUserExistsModal = this.dismissUserExistsModal.bind(this);

        this.showLoginMessage = this.showLoginMessage.bind(this);
        this.hideLoginMessages = this.hideLoginMessages.bind(this);
        this.updatePrimaryLocation = this.updatePrimaryLocation.bind(this);
        this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
    }

    goNextStep(event) {
        event.preventDefault();

        if (this.state.isCreatingAccount) {
            return;
        }

        this.props.updateApplicationState('primaryPracticeLocation', this.props.stepState.primaryPracticeLocation);
        this.props.updateApplicationState('primaryDistrictLocation', this.props.stepState.primaryDistrictLocation);
        this.props.updateStepState('applicationSubmitted', true);

        const stepChangeCleanup = () => {
            this.props.updateApplicationState('applicationCreated', true);
        }

        if (this.props.appState.userLoggedIn) {
            if (this.props.appState.isInternational) {
                this.updatePrimaryLocation();
            }
            this.props.goToStep(event, 3, stepChangeCleanup);
        } else {
            this.setState({ isCreatingAccount: true });

            if (window.grecaptcha) {
                grecaptcha.reset();
                this.setState({ recaptchaToken: null });
            }

            try {
                grecaptcha.execute();
            } catch (error) {
                console.error('ReCAPTCHA execution failed:', error);
                this.setState({ isCreatingAccount: false });
                this.props.setErrorModalData('ReCAPTCHA verification failed. Please try again.');
                this.props.showErrorModal();
            }
        }
    }

    onRecaptchaChange(token) {
        if (token && !this.state.recaptchaToken) {
            this.setState({ recaptchaToken: token });
            this.createNewAccount(token);
        }
    }

    updatePrimaryLocation() {
        var updatedRecord = { PrimaryPracticeLocation: this.props.stepState.primaryPracticeLocation, districtCode: null };
        var fullUrl = '/api/account/updateprimarypracticelocation';
        accountDataService.postData(fullUrl, updatedRecord).then(() => emitter.emit('primaryLocationChanged'));
    }

    createNewAccount(recaptchaToken) {
        if (!this.state.isCreatingAccount || this.state.recaptchaToken !== recaptchaToken) {
            return;
        }

        this.props.disableUI();

        var gresponse = recaptchaToken || grecaptcha.getResponse();

        if (!gresponse) {
            this.setState({
                isCreatingAccount: false,
                recaptchaToken: null
            });
            this.props.enableUI();
            this.props.setErrorModalData('ReCAPTCHA verification failed. Please try again.');
            this.props.showErrorModal();
            return;
        }

        // Must include empty strings for address fields or API will error
        var createAccountData = {
            FirstName: this.props.stepState.firstName,
            MiddleName: this.props.stepState.middleName,
            LastName: this.props.stepState.lastName,
            Prefix: this.props.stepState.prefix,
            Suffix: this.props.stepState.suffix,
            Password: this.props.stepState.password,
            Email: this.props.stepState.email,
            Credentials: this.props.stepState.credentials ? this.props.stepState.credentials.map((cred) => cred).join(',') : '',
            AddressType: '',
            Address1: '',
            Address2: '',
            Address3: '',
            Address4: '',
            PostalCode: '',
            City: '',
            State: '',
            CountryCode: '',

            primaryPracticeLocation: this.props.stepState.primaryPracticeLocation,
            primaryDistrictLocation: this.props.stepState.primaryDistrictLocation,

            // xconnect stuff
            email: this.props.stepState.email,
            appType: this.props.appState.appType,
            productType: this.props.appState.productType,
            rateType: this.props.appState.rateType,
            isMilitary: this.props.appState.isMilitary,
            isGovernmentEmployee: this.props.appState.isGovernmentEmployee,
            applicationSubmitted: this.props.stepState.applicationSubmitted,
            MasterCustomerId: this.props.stepState.MasterCustomerId,
            EncryptedId: this.props.stepState.EncryptedId,

            RecaptchaResponse: gresponse
        };

        if (!createAccountData.RecaptchaResponse || createAccountData.RecaptchaResponse.trim() === '') {
            console.warn('No valid ReCAPTCHA response found, aborting account creation');
            this.setState({
                isCreatingAccount: false,
                recaptchaToken: null
            });
            this.props.enableUI();
            return;
        }

        var createAccountError = (response) => {
            var errorMessage = labels.step2.defaultCreateAccountError;

            if (response &&
                response.personifyErrors &&
                response.personifyErrors.Errors &&
                response.personifyErrors.Errors.length) {
                errorMessage = response.personifyErrors.Errors.join('  ');
            } else if (response && response.message) {
                errorMessage = response.message;
            }

            this.setState({
                isCreatingAccount: false,
                recaptchaToken: null
            });

            this.props.setErrorModalData(errorMessage);
            this.props.enableUI();
            this.props.showErrorModal();
        };

        //var createAccountResponse = (response) => {
        //    if (response && response.resultStatus && response.resultStatus && response.resultStatus.Success) {
        //        accountDataService.imitateFormSubmit("/api/reactforms/LoginUserAfterCreateAccount", {
        //            email: this.props.stepState.email,
        //            password: this.props.stepState.password
        //        });
        //    } else {
        //        createAccountError(response);
        //    }
        //};

        accountDataService.postData("/api/reactforms/createaccountfrommemberjoin", createAccountData)
            .then((response) => {
                if (response && response.resultStatus && response.resultStatus.Success) {
                    this.props.showLoginInfoModal('loginmodal');
                } else {
                    createAccountError(response);
                }
            })
            .catch((error) => {
                console.error('Account creation failed:', error);
                if (error.status) {
                    error.json().then(errorData => {
                        createAccountError(errorData);
                    }).catch(() => {
                        createAccountError({ message: `HTTP ${error.status}: ${error.statusText || 'Unknown error'}` });
                    });
                } else {
                    createAccountError(error);
                }
            })
            .finally(() => {
                this.setState({
                    isCreatingAccount: false,
                    recaptchaToken: null
                });
            });
    }

    checkIfEmailExists(event) {
        // call api and check if an account exists with this email.
        if (this.state.emailAddress !== this.props.stepState.emailAddress) {
            var handleEmailCheck = (response) => {
                this.setState({
                    emailAccountExists: response.response
                });
            }

            accountDataService.postData(accountDataService.memberJoinPostUrl.checkIfEmailExists(), event.target.value)
                .then(handleEmailCheck)
                .catch((error) => {
                    console.error('Email check failed:', error);
                });
        }

        this.checkIfUserExists();
    }

    checkIfUserExists() {
        if (this.props.stepState.firstName &&
            this.props.stepState.firstName.length > 1 &&
            this.props.stepState.lastName &&
            this.props.stepState.lastName.length > 1) {

            this.checkUser(this.props.stepState.firstName, this.props.stepState.lastName);
        } else if (this.state.userAccountExists) {
            this.setState({
                userAccountExists: false
            });
        }
    }

    checkUser(firstName, lastName) {
        var handleUserCheck = (response) => {
            if (response.response.ResultStatus.Success) {
                this.setState({
                    userAccountExists: response.response &&
                        response.response.CustomersMaskInfo &&
                        response.response.CustomersMaskInfo.length > 0
                        ? true
                        : false,
                    customersMaskInfo: response.response.CustomersMaskInfo
                });
            } else {
                this.setState({
                    userAccountExists: false
                });
            }
        };

        accountDataService.getDataWithUrl(accountDataService.getRequestUrl.checkIfUserExists(firstName, lastName))
            .then(handleUserCheck)
            .catch((error) => {
                console.error('User check failed:', error);
                this.setState({
                    userAccountExists: false
                });
            });
    }

    handleEmailInputChange(event) {
        this.setState({
            emailAddress: event.target.value
        });

        this.props.updateStepState(event.target.name, event.target.value);
    }

    prevStepValid() {
        return this.props.appState.currentStep > 0 || this.props.appState.debugMode;
    }

    nextStepValid() {
        return !this.state.emailAccountExists &&
            !this.state.isCreatingAccount &&
            (this.props.appState.currentStep < 6 || this.props.appState.debugMode);
    }

    checkUserExistingModal() {
        if (!this.state.dismissMaskedUsers && this.state.userAccountExists) {
            this.hideLoginMessages();
            $('#userExistsModal').modal('show');
        }
    }

    dismissUserExistsModal() {
        this.setState({
            dismissMaskedUsers: true
        });

        $('#userExistsModal').modal('hide');
        this.hideLoginMessages();
    }

    showLoginMessage(index) {
        this.hideLoginMessages();
        var id = "#loginMessage" + index;

        $(id)[0].style.display = "inline-block";
    }

    hideLoginMessages() {
        $('.login-message').each(function (index, message) {
            message.style.display = "none";
        });
    }

    render() {
        return <div className={"step-2-container"}>
            <$form onSubmit={this.goNextStep} ref={c => { this.form = c }}>

                <EmailAndPassword handleEmailInputChange={this.handleEmailInputChange} checkUserExistingModal={this.checkUserExistingModal} checkIfEmailExists={this.checkIfEmailExists} emailAccountExists={this.state.emailAccountExists} {...this.props} />
                <CreateProfile dismissUserExistsModal={this.dismissUserExistsModal} customersMaskInfo={this.state.customersMaskInfo} showLoginMessage={this.showLoginMessage} checkUserExistingModal={this.checkUserExistingModal} userAccountExists={this.state.userAccountExists} checkIfUserExists={this.checkIfUserExists} {...this.props} />
                <Credentials checkUserExistingModal={this.checkUserExistingModal} {...this.props} />

                <ChangeStepButtons
                    disableUI={this.props.appState.disableUI}
                    nextStepValid={this.nextStepValid}
                    prevStepValid={this.prevStepValid}
                    goPrevStep={this.props.goPrevStep}
                    currentStep={this.props.appState.currentStep} />
                <React.Suspense fallback={null}>
                    <ReCAPTCHA
                        ref={_recaptchaRef}
                        size="invisible"
                        sitekey={labels.step2.siteKey}
                        onChange={this.onRecaptchaChange}
                    />
                </React.Suspense>
            </$form>
        </div>;
    }
}

module.exports = Step2;